import { render, staticRenderFns } from "./FullData.vue?vue&type=template&id=ce52be02&"
import script from "./FullData.vue?vue&type=script&lang=js&"
export * from "./FullData.vue?vue&type=script&lang=js&"
import style0 from "./FullData.vue?vue&type=style&index=0&id=ce52be02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports